import { useEffect, useState } from 'react';
import EnterEmail from './EnterEmail';
import CheckYourEmail from './CheckYourEmail';
import ConfirmEmail from './ConfirmEmail';
import VerifiedEmail from './VerifiedEmail';
import UserSignUp from './UserSignUp';
import GetStarted from './GetStarted';

type FormData = {
  email: string;
  isCheckedEmail: boolean;
  isConfirmedEmail: boolean;
  isEmailVerified: boolean;
  fullName: string;
  password: string;
  userExists: boolean;
  tempPassword: string;
};

const INITIAL_DATA: FormData = {
  email: '',
  isCheckedEmail: false,
  isConfirmedEmail: false,
  isEmailVerified: false,
  fullName: '',
  password: '',
  userExists: true,
  tempPassword: '',
};

const SignUpWrapper = () => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [data, setData] = useState(INITIAL_DATA);
  const updateFields = (fields: Partial<FormData>) => {
    setData((prev) => {
      return { ...prev, ...fields };
    });
  };

  // Steps
  const defaultSteps = [
    <EnterEmail {...data} nextStep={next} updateFields={updateFields} />,
    <CheckYourEmail {...data} nextStep={next} updateFields={updateFields} />,
    <ConfirmEmail {...data} nextStep={next} updateFields={updateFields} />,
    <VerifiedEmail {...data} nextStep={next} updateFields={updateFields} />,
    <UserSignUp {...data} nextStep={next} updateFields={updateFields} />,
    <GetStarted {...data} nextStep={next} updateFields={updateFields} />,
  ];

  const [steps, setSteps] = useState(defaultSteps);

  useEffect(() => {
    setSteps(defaultSteps);
  }, [data]);

  function next() {
    setCurrentStepIndex((i) => {
      return i + 1;
    });
  }
  return <div>{steps[currentStepIndex]}</div>;
};

export default SignUpWrapper;
